export default function normalizeCurrency(num: number) {
  return num?.toLocaleString("ru")?.split(" ").join(".");
}
